<div class="flex flex-col md:flex-row h-screen">
  <!-- Sidebar con logo -->
  <div class="w-full md:w-1/2 bg-blue-100 flex items-center justify-center fade-in">
    <img
      src="logo.webp"
      alt="Logo"
      class="w-48 h-48 md:w-96 md:h-96 border-4 border-blue-900 rounded-lg shadow-lg"
    />
  </div>

  <!-- Contenido principal -->
  <div class="w-full md:w-1/2 flex flex-col items-center justify-center fade-in">
    <h1 class="text-3xl font-bold mb-8 text-blue-900">Selecciona tu rol</h1>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 p-4">
      <!-- Botón 1: Administrador -->
      <button
        class="btn-role bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 w-64 text-center flex flex-col items-center justify-center"
        (click)="selectRole(1)"
      >
        <i class="fas fa-user-shield text-5xl text-blue-900 mb-4"></i>
        <span class="text-lg font-semibold text-blue-900 leading-tight">Administrador</span>
      </button>

      <!-- Botón 2: Especialista (Gestión de Documentos) -->
      <button
        class="btn-role bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 w-64 text-center flex flex-col items-center justify-center"
        (click)="selectRole(2)"
      >
        <i class="fas fa-file-alt text-5xl text-blue-900 mb-4"></i>
        <span class="text-lg font-semibold text-blue-900 leading-tight">
          Especialista <br />
          (Gestión de Documentos)
        </span>
      </button>

      <!-- Botón 3: Especialista (Gestión de Evaluaciones) -->
      <button
        class="btn-role bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 w-64 text-center flex flex-col items-center justify-center"
        (click)="selectRole(3)"
      >
        <i class="fas fa-check-circle text-5xl text-blue-900 mb-4"></i>
        <span class="text-lg font-semibold text-blue-900 leading-tight">
          Especialista <br />
          (Gestión de Evaluaciones)
        </span>
      </button>

      <!-- Botón 4: Estudiante -->
      <button
        class="btn-role bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 w-64 text-center flex flex-col items-center justify-center"
        (click)="selectRole(4)"
      >
        <i class="fas fa-user-graduate text-5xl text-blue-900 mb-4"></i>
        <span class="text-lg font-semibold text-blue-900 leading-tight">Estudiante</span>
      </button>

      <!-- Botón 5: Institución Educativa -->
      <button
        class="btn-role bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 w-64 text-center flex flex-col items-center justify-center"
        (click)="selectRole(5)"
      >
        <i class="fas fa-school text-5xl text-blue-900 mb-4"></i>
        <span class="text-lg font-semibold text-blue-900 leading-tight">
          Institución <br />
          Educativa
        </span>
      </button>
    </div>
  </div>
</div>
